import { ScoreDescription } from '@wilson/shift/core';

export function generateScoreViewDetail(
  score: number,
): Pick<ScoreDescription, 'backgroundColor' | 'widthPercentage'> {
  const widthPercentage = Math.round(score * 100);

  return {
    widthPercentage,
    backgroundColor: getColorByValue(widthPercentage),
  };
}

function getColorByValue(value: number) {
  if (value < 40) return 'var(--red-5)';
  if (value <= 60) return 'var(--gold-4)';
  else return 'var(--primary)';
}
